import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

export interface TendenciaPontuacao {
  title: string;
  icon: string;
  color: string;
}

const CONFIG: Record<string, TendenciaPontuacao> = {
  negativo: {
    title: 'Tendência negativa em relação ao comparativo',
    icon: 'pi pi-arrow-down',
    color: 'red',
  },
  positivo: {
    title: 'Tendência positiva em relação ao comparativo',
    icon: 'pi pi-arrow-up',
    color: 'green',
  },
  neutro: {
    title: 'Tendência neutra em relação ao comparativo',
    icon: 'pi pi-minus',
    color: '#cccc00',
  },
  nulo: {
    title: 'Tendência neutra em relação ao comparativo',
    icon: 'pi pi-minus',
    color: 'white',
  },
};

export const NAO_PONTUADO = ['NP', 'NA'];
export const INCONSISTENTE = ['IN', 'INC'];
export const VALOR_VAZIO_EM_BRANCO = ['VA', 'VE', 'NI'];

export const resolverTendencia = (vlPontuacao: any, vlPontuacaoPrevia: any): TendenciaPontuacao => {
  if (vlPontuacaoPrevia == null) return null;

  if (!vlPontuacao) return CONFIG.nulo;
  if (+vlPontuacao < +vlPontuacaoPrevia) return CONFIG.negativo;
  if (+vlPontuacao > +vlPontuacaoPrevia) return CONFIG.positivo;

  return CONFIG.neutro;
};

@Component({
    selector: 'bl-simulador-valores-pontuacao',
    templateUrl: './simulador-valores-pontuacao.component.html',
    styleUrls: ['./simulador-valores-pontuacao.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SimuladorValoresPontuacaoComponent implements OnChanges {
  @Input() vlPontuacao: any;
  @Input() idPrecisao: any;
  @Input() vlPontuacaoPrevia: any;
  @Input() pcDeltaPrevia: any;
  @Input() decimais: number = 4;

  pontuado = true;
  inconsistente = false;
  vazio = false;
  tendencia: TendenciaPontuacao;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.vlPontuacao == null) {
      this.vazio = VALOR_VAZIO_EM_BRANCO.includes(this.idPrecisao);
    }

    if (NAO_PONTUADO.includes(this.idPrecisao)) {
      this.pontuado = false;
      return;
    }
    this.pontuado = true;

    if (INCONSISTENTE.includes(this.idPrecisao)) {
      this.inconsistente = true;
      return;
    }
    this.inconsistente = false;

    this.tendencia = resolverTendencia(this.vlPontuacao, this.vlPontuacaoPrevia);
  }
}
